import { request } from "./axio";
export const Chat = {
  listConversation: (params) => {
    return request.get(`/ms-chat-2/api/v1/conversation/query`, params);
  },
  getShopInfo: (params) => {
    return request.get(
      "/ms-business-management/api/business-with-version/ver2/get-list",
      params
    );
  },
  countUseenMessage: (params) => {
    return request.get(
      `/ms-chat-2/api/v1/messages/count-unseen-message`,
      params
    );
  },
  authUser: (params) => {
    return request.get("/ms-user-management/api/auth", params);
  },
  getHistoryChat: (params) => {
    return request.get(`/ms-chat-2/api/v1/messages/query`, params);
  },
  createMessage: (params, header) => {
    return request.post(`/ms-chat-2/api/v1/messages/create`, params, header);
  },
  upDateRMessage: (newMessages, header) => {
    return request.post(
      `/ms-chat-2/api/v1/messages/received-messages`,
      newMessages,
      header
    );
  },
  getActiveUserChat: (params, id) => {
    return request.get(`/ms-chat-2/api/v1/is-online/users/${id}`, params);
  },
  getOneConversation: (params, id) => {
    return request.get(`/ms-chat-2/api/v1/conversation/get-one/${id}`, params);
  },

  getOneConversationNotExistInList: (params) => {
    return request.get(
      "/ms-chat-2/api/v1/conversation/get-or-create-by-sender",
      params
    );
  },

  getProducts: (params) => {
    return request.get("/finan-product/api/v1/product/buyer/get-list", params);
  },
  getOneProduct: (params, id) => {
    return request.get(
      `/finan-product/api/v1/product/buyer/get-detail/${id}`,
      params
    );
  },
  getOrders: (params) => {
    return request.get(
      "/finan-order/api/v2/chat/get-list-order?sort=created_at desc",
      params
    );
  },
  getOneOrder: (params, orderNumber) => {
    return request.get(
      `/finan-order/api/v1/buyer/get-one-order/${orderNumber}`,
      params
    );
  },
};
